import { useNode, useEditor } from "@craftjs/core";
import React, { useEffect, useState } from "react";
import GrigoraCSSRenderer from "./../css-render";
import { ProductHuntSettings } from "./settings";
import icon from "./icon";
import classnames from "classnames";
import { getDynamicCSS, getSupportProps } from "../../block-supports";

export const ProductHunt = (props) => {
  const {
    id,
    connectors: { connect, drag },
    actions: { setProp },
  } = useNode((state) => ({
    id: state.id,
    selected: state.events.selected,
    dragged: state.events.dragged,
  }));

  const {
    actions: { selectNode },
  } = useEditor();

  const { url, post, theme = "light", embedType, badge } = props;

  var blockProps = getSupportProps({
    id,
    ...props,
  });

  const wrapperClass = classnames(
    {
      "g-product-hunt": true,
      [`product-hunt-${id}`]: id,
    },
    blockProps.className,
  );

  const checkImageExists = (url) => {
    const img = new Image();
    img.src = url;

    img.onload = () => {
      setProp((props) => {
        props.badge = url;
      });
    };

    img.onerror = () => {
      setProp((props) => {
        props.badge = "";
      });
    };
  };

  useEffect(() => {
    checkImageExists(
      `https://api.producthunt.com/widgets/embed-image/v1/${
        !embedType || embedType === "drive-support"
          ? "featured"
          : embedType === "product-of-the-day" ||
            embedType === "product-of-the-week"
          ? "top-post-badge"
          : "top-post-topic-badge"
      }.svg?post_id=${post ? post.id : ""}&theme=${theme}&period=${
        embedType === "product-of-the-day"
          ? "daily"
          : embedType === "product-of-the-week"
          ? "weekly"
          : ""
      }`,
    );
  }, [post, theme, embedType]);

  return (
    <div
      {...blockProps}
      ref={(ref) => connect(drag(ref))}
      className={wrapperClass}
      onFocus={() => {
        selectNode(id);
      }}
      data-grigora-block="true"
      data-grigora-block-id={id}
    >
      <style>{`${getDynamicCSS(id, props)}`}</style>
      <style>{`${GrigoraCSSRenderer.blockCSS__ProductHunt(id, props)}`}</style>
      {post && url !== "" ? (
        badge !== "" ? (
          <a
            onClick={(e) => {
              e.preventDefault();
            }}
            href={url ? url : "https://www.producthunt.com/"}
            target="_blank"
            rel="noreferrer"
            className="product-hunt-link"
          >
            <img
              src={badge}
              className="product-hunt-image"
              alt={post ? post.name : "Product Hunt"}
            />
          </a>
        ) : (
          <div>Badge doesn&apos;t exists!</div>
        )
      ) : (
        <div className="empty-container">Product Hunt: Add Product URL</div>
      )}
    </div>
  );
};

// To Avoid Mangling in Production
ProductHunt.displayName = "ProductHunt";

ProductHunt.craft = {
  name: "Product Hunt",
  props: {},
  related: {
    settings: ProductHuntSettings,
    icon: icon,
    supports: [
      "grigora/entrance-animations",
      "grigora/css-transform-animations",
      "grigora/mouse-movement",
      "grigora/visibility",
      "grigora/position",
      "grigora/sticky",
      "grigora/filter",
      "grigora/custom-class",
      "grigora/custom-id",
    ],
    keywords: ["ProductHunt"],
    category: "miscellaneous",
    isHiddenInPostEditor: true,
  },
  custom: {
    name: "ProductHunt",
    slug: "grigora/product-hunt",
  },
};
